export const SIDE_PANEL_WIDTH_KEY = 'rhythm-e.sidePanelWidth';
export const SIDE_PANEL_MIN_WIDTH = 280;
export const SIDE_PANEL_DEFAULT_WIDTH = 320;
export const SIDE_PANEL_MAX_VIEWPORT_RATIO = 0.7;
export const SIDE_PANEL_MAIN_RESERVE = 320;

export function clampSidePanelWidth(
  width,
  viewportWidth = typeof window !== 'undefined' ? window.innerWidth : 1280,
) {
  const viewport = Number(viewportWidth);
  const safeViewport = Number.isFinite(viewport) && viewport > 0 ? viewport : 1280;
  const min = SIDE_PANEL_MIN_WIDTH;
  const max = Math.max(
    min,
    Math.min(
      safeViewport * SIDE_PANEL_MAX_VIEWPORT_RATIO,
      safeViewport - SIDE_PANEL_MAIN_RESERVE,
    ),
  );
  const requested = Number(width);
  const value = Number.isFinite(requested) ? requested : SIDE_PANEL_DEFAULT_WIDTH;
  return Math.round(Math.min(Math.max(value, min), max));
}

export function readStoredSidePanelWidth(viewportWidth) {
  try {
    const raw = localStorage.getItem(SIDE_PANEL_WIDTH_KEY);
    if (raw == null) return clampSidePanelWidth(SIDE_PANEL_DEFAULT_WIDTH, viewportWidth);
    return clampSidePanelWidth(Number(raw), viewportWidth);
  } catch {
    return SIDE_PANEL_DEFAULT_WIDTH;
  }
}

export function writeStoredSidePanelWidth(width, viewportWidth) {
  try {
    localStorage.setItem(
      SIDE_PANEL_WIDTH_KEY,
      String(clampSidePanelWidth(width, viewportWidth)),
    );
  } catch {
    // Ignore quota / private-mode failures.
  }
}

export function applySidePanelWidthVar(width, viewportWidth) {
  if (typeof document === 'undefined') return;
  document.documentElement.style.setProperty(
    '--side-panel-width',
    `${clampSidePanelWidth(width, viewportWidth)}px`,
  );
}
